var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54973 2.63611L17.3467 2.63611C18.1019 2.63596 18.7689 3.12854 18.991 3.85043L21.3723 11.5904C21.5327 12.1119 21.4362 12.6785 21.1123 13.1175C20.7883 13.5564 20.2753 13.8157 19.7297 13.8161L13.7097 13.8161L13.7097 17.2561C13.7097 19.2969 12.6339 20.261 11.3327 20.5757C11.0755 20.6361 10.8048 20.5757 10.5977 20.4117C10.3906 20.2476 10.2698 19.998 10.2697 19.7338V16.3961L5.96973 11.2361",
    stroke: "#171A1F",
    strokeWidth: 2.064,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00982 12.9644H2.56982L2.56982 2.64436H6.00982L6.00982 12.9644Z",
    stroke: "#171A1F",
    strokeWidth: 2.064,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlike);
export default __webpack_public_path__ + "static/media/unlike.11ba59c7f9ce4bc17fbf1e6efde40853.svg";
export { ForwardRef as ReactComponent };